import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GeneratedBrandPage, HostedBrandPage } from 'components/BrandPage/BrandPageComponent';
import { NotFound } from 'components/NotFound/Container/NotFound';
import { getCmsClient } from 'common/utilities/cmsClient';
import { getNavigationLinkContent } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import isEmpty from 'lodash/isEmpty';
import mapValues from 'lodash/mapValues';
import keyBy from 'lodash/keyBy';
import { BrandPageTemplates } from 'app/Constants';
import KfcActivityIndicator from 'app/KfcActivityIndicator';

const { Template1, Template2 } = BrandPageTemplates;

const getBrandPageRoute = (rest, routePath, hideNav, contentType) => {
  if (!isEmpty(contentType)) {
    return (
      <Route
        {...rest}
        render={props => {
          if (contentType === Template1) {
            return <HostedBrandPage routePath={routePath} hideNav={hideNav} {...props} />;
          }
          if (contentType === Template2) {
            return <GeneratedBrandPage routePath={routePath} hideNav={hideNav} {...props} />;
          }
        }}
      />
    );
  }
};

const getRoutePath = (locationPathName, setHideNavBar) => {
  let pathName = locationPathName;
  if (locationPathName?.includes('/true') || locationPathName?.includes('/false')) {
    const hideNav = locationPathName?.includes('/true') ?? !locationPathName?.includes('/false');
    setHideNavBar(hideNav);
    const paths = locationPathName?.split(`/${hideNav}`);
    pathName = paths[0];
  }
  return pathName;
};

const BrandPageRoute = ({ ...rest }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigationLinkContent =
    useSelector(
      ({
        contentReducer: { navigationLinkResponse: { fields = [] } = {}, isContentfulLoading: isLoading = true } = {},
      }) => ({
        fields,
        isLoading,
      }),
    ) ?? {};
  const [isLoadingBrandPageRoute, setIsLoadingBrandPageRoute] = useState(true);

  const [brandPageRoute, setBrandPageRoute] = useState(null);
  const [routePath, setRoutePath] = useState(null);
  const [hideNavBar, setHideNavBar] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(true);

  useLayoutEffect(() => {
    dispatch(
      getNavigationLinkContent({
        cmsClient: getCmsClient(),
        query: {
          content_type: 'navigationLink',
          select: 'sys.id,fields.brandPageTemplate,fields.internalurl',
          'fields.brandPageTemplate[in]': `${Template1},${Template2}`,
          include: '5',
        },
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    setRoutePath(getRoutePath(location?.pathname, setHideNavBar));
    setIsInitialRender(true);
  }, [location?.pathname]);

  useEffect(() => {
    if (!isEmpty(navigationLinkContent?.fields) && !isEmpty(routePath) && isInitialRender) {
      setIsInitialRender(false);
      const brandPageNavLinks =
        mapValues(keyBy(navigationLinkContent?.fields, 'internalurl'), 'brandPageTemplate') ?? {};
      const brandRoute = getBrandPageRoute(rest, routePath, hideNavBar, brandPageNavLinks?.[routePath]);
      setBrandPageRoute(brandRoute);
      setIsLoadingBrandPageRoute(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialRender, navigationLinkContent?.fields, routePath]);

  if (isLoadingBrandPageRoute) {
    return <KfcActivityIndicator isInProgress={true} />;
  }

  if (brandPageRoute) {
    return <>{brandPageRoute}</>;
  }

  return <Route component={NotFound} />;
};

export default BrandPageRoute;
